// extracted by mini-css-extract-plugin
export default {"container":"d_qBH5","title":"yUHyZN","textButton":"IYngo2"};